import {
  Box,
  Text,
  Card,
  BlockStack,
  InlineStack,
  Icon
} from '@shopify/polaris'

import { useState } from 'react'

function CategoryCard({ i, title, value, icon, typeTab, setTypeTab, hovering, setHovering }) {
  return (
    <Box onMouseEnter={() => setHovering(i)} onMouseLeave={() => setHovering(null)} onClick={() => setTypeTab(i)}>
      <Card padding="0" background={hovering === i ? 'bg-success-subdued-hover' : 'bg'}>
        <Box padding="500">
          <BlockStack gap="200">
            <InlineStack align="space-between">
              <Text variant="bodyLg">{title}</Text>
              <InlineStack>
                <Icon color="subdued" source={icon} />
              </InlineStack>
            </InlineStack>
            <Text variant="headingXl">{value}</Text>
          </BlockStack>
        </Box>
        {
          typeTab === i ? <div style={{ width: '100%', height: '5px', backgroundColor: 'green' }} /> : null
        }
      </Card>
    </Box>
  )
}

export default function CategoryCards({ cards, typeTab, setTypeTab }) {
  const [hovering, setHovering] = useState(null)
  return cards?.map((card, i) => {
    return (<CategoryCard
      key={i}
      i={i}
      {...card}
      hovering={hovering}
      setHovering={setHovering}
      typeTab={typeTab}
      setTypeTab={setTypeTab}
    />)
  })
}
